<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import { getDateTimeFormatPattern } from 'shared/helpers/formatTime';
import {
  buildActivitySentenceText,
  summarizeLastChange,
} from 'dashboard/helper/planningEventAuditHistoryHelper';

const props = defineProps({
  lastChange: { type: Object, default: null },
  compact: { type: Boolean, default: false },
});

const { t } = useI18n();

const summary = computed(() =>
  summarizeLastChange(props.lastChange, {
    agentBotLabel: t('PLANNING.SHOW.HISTORY_AGENT_BOT'),
    systemLabel: t('PLANNING.SHOW.HISTORY_SYSTEM'),
  })
);

const line = computed(() => {
  if (!summary.value?.entries?.length) return summary.value?.changeLine;
  return buildActivitySentenceText(summary.value.entries[0], {
    includeActor: true,
  });
});
</script>

<template>
  <div
    v-if="summary && line"
    class="flex items-center gap-1.5 min-w-0 text-n-slate-10"
    :class="compact ? 'text-xs' : 'text-sm'"
  >
    <Icon icon="i-lucide-history" class="size-3.5 shrink-0" />
    <span class="truncate">
      {{ line }}
      <template v-if="summary.createdAt">
        ·
        {{
          messageTimestamp(
            summary.createdAt,
            getDateTimeFormatPattern('MMM dd, yyyy')
          )
        }}
      </template>
    </span>
  </div>
</template>
